<div class="basicrow tabtopb f-black roboto-r f-reg">
  <div class="basicrow m-bott-ii">
      <div class="tabla-consumo">
        <div class="boxtbl">
          <div class="basicrow m-sides">
            <div class="b-title noline">
              <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
                <div class="tabcell">
                  Consumo
                </div>
              </div>
            </div>
          </div>
          <div class="tab-tbar h-def-ii">
            <div class="frwds rline trds vcenter">
              <div class="tabcell">
                Minutos
              </div>
            </div>
            <div class="frwds rline-i trds vcenter">
              <div class="tabcell">
                SMS / MMS
              </div>
            </div>
            <div class="frwds trds hidden-xs">
              <div class="autocont full vcenter">
                <div class="tabcell">
                  Datos
                </div>
              </div>
            </div>
          </div>
          <div class="basicrow">
            <div class="tab-cbar h-def-iii topgbrd" *ngIf="this.usage2[this.index].subscriber.length > 0">
              <div class="frwds trds rline vcenter trds-b">
                <div class="tabcell-min">
                  <span class="roboto-b">Minutos Usados</span><br />
                  <span class="f-red f-big line-h-i roboto-b">
                    {{this.useminvoice}}
                  </span>
                </div>
              </div>
              <div class="frwds trds rline-i vcenter trds-b">
                <div class="tabcell-mms">
                  <span class="roboto-b">SMS / MMS Usados</span><br />
                  <span class="f-red f-big line-h-i roboto-b">
                    {{this.mms}}
                  </span>
                </div>
              </div>
              <div class="frwds trds fulltrd vcenter" *ngIf="this.usage2[this.index].subscriber.length > 0">
                  <span class="roboto-b labelConsumo">Consumo Total</span>
                  <span class="basicrow m-top-ii" *ngFor="let paquete of this.usage2[this.index].subscriber; let j = index">
                    <div *ngIf="j==0">
                      <app-graphic [indexI]="this.index" [indexJ]="j"></app-graphic>
                      <span class="basicrow f-mini f-black roboto-b text-right" style="padding-top: 10px;margin-bottom: 16px;">
                        {{this.paquete.iDLocalText}} USADOS
                      </span>
                    </div>
                  </span>
              </div>
              <div class="frwds trds fulltrd vcenter no-data" *ngIf="this.usage2[this.index].subscriber.length == 0">
                <div class="tabcell">
                  <span class="roboto-b">No hay datos de consumo.</span><br />
                </div>
              </div>
            </div>
            <div class="tab-cbar h-def-ii topgbrd" *ngIf="this.usage2[this.index].subscriber.length == 0">
              <div class="frwds trds rline vcenter consumoB">
                <div class="tabcell">
                  <span class="roboto-b">Minutos Usados</span><br />
                  <span class="f-red f-big line-h-i roboto-b">
                    {{useminvoice}}
                  </span>
                </div>
              </div>
              <div class="frwds trds rline-i fulltrd vcenter trds-b consumoB">
                <div class="tabcell">
                  <span class="roboto-b">SMS / MMS Usados</span><br />
                  <span class="f-red f-big line-h-i roboto-b">
                    {{mms}}
                  </span>
                </div>
              </div>
              <div class="tab-tbar visible-xs">
                <div class="autocont full text-center vcenter">
                  <div class="tabcell">
                    Datos
                  </div>
                </div>
              </div>
              <div class="frwds trds fulltrd vcenter consumoB" *ngIf="this.usage2[this.index].subscriber.length > 0">
                <div class="tabcell">
                  <span class="roboto-b">Consumo Total</span><br />
                  <span class="basicrow m-top-ii"
                    *ngFor="let paquete of this.usage2[this.index].subscriber; let j = index">
                    <div *ngIf="j==0">
                      <app-graphic [indexI]="this.index" [indexJ]="j"></app-graphic>
                      <span class="basicrow f-mini f-black roboto-r text-right">
                        {{paquete.iDLocalText}} DE {{paquete.DLocalTop}} USADOS
                      </span>
                    </div>
                  </span>
                </div>
              </div>
              <div class="frwds trds fulltrd vcenter no-data" *ngIf="this.usage2[this.index].subscriber.length == 0">
                <div class="tabcell">
                  <span class="roboto-b">No hay datos de consumo.</span><br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>